<template>
  <div
    class="col-12 d-flex align-items-center justify-content-between"
    style=""
  >
    <div v-if="center"></div>
    <div v-if="itemName" v-dompurify-html="itemName"></div>
    <div class="d-flex">
      <div v-if="rightName != ''" v-dompurify-html="rightName"></div>
      <div>
        <img src="@/assets/必須.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequiredItem',
  props: {
    itemName: String,
    rightName: String,
    center: Boolean
  }
}
</script>

<style scoped lang="scss"></style>
